import { commandFactory } from './load-ads';
import onBidsReturned from './on-bids-returned-callback';
import { CommandFactoryParams } from '../types';

export default async (commandFactoryParams: CommandFactoryParams, isAdRefresh = false) => {
    const { pbjs } = commandFactoryParams;

    const biddingPromise = new Promise((resolve) => {
        pbjs.que.push(commandFactory(commandFactoryParams, resolve));
    }).then(() => onBidsReturned(commandFactoryParams, isAdRefresh));

    await biddingPromise;
};
